import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectToken } from '../../auth/ducks';


const mapStateToProps = (state, props) => ({
  fileId: props.params.fileId,
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {},
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class HandleFileDownloadContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    fileId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { fileId, token } = this.props;
    window.location.replace(`${process.env.REACT_APP_API_URL}/file/${fileId}?token=${token}`)
    
  }

  render() {
    return <div />
  }
}



// WEBPACK FOOTER //
// ./src/features/files/containers/HandleFileDownloadContainer.js